<img src="assets/images/colorbar.svg" alt="" class="ds-colorbar" />

